import type { FC } from "react";
import type { Doc } from "sharedb/lib/client";

import type { WorksheetType } from "../../../../shared/types/worksheet";
import { hasEditableBlocks } from "../../../../shared/worksheets/doc-helpers";

import { PageOverviewHeader } from "components/materials/page/content/PageOverviewHeader";
import { useNameFromPageAccessId } from "components/materials/page/helpers";
import { FeatureSimpleHeader } from "components/materials/presentation/featuring/header/FeatureSimpleHeader";
import { PageType } from "components/server-types";
import { FeatureStatus } from "utils/presentation";

type ProjectorHeaderProps = {
  doc: Doc<WorksheetType> | undefined;
  page: PageType;
  featureStatus: FeatureStatus;
  accessId: string | undefined | null;
  blockId: string | undefined | null;
};

export const ProjectorHeader: FC<ProjectorHeaderProps> = ({
  doc,
  page,
  featureStatus,
  accessId,
  blockId,
}) => {
  const blocks = doc?.data?.b;
  const presentedBlock = blocks?.find((b) => b.id === blockId);
  const responseName = useNameFromPageAccessId(accessId, page.id);
  const isFeaturing = featureStatus !== FeatureStatus.NONE;
  const isStaticContent = !hasEditableBlocks(doc);

  return (
    <div className="projector-view-header flex w-full items-center justify-center">
      <div className="flex w-full justify-between gap-1">
        <div className="flex w-full grow items-center gap-3">
          <h1 className="my-0 text-black-tint-20">{page.title}</h1>

          {isFeaturing && (
            <FeatureSimpleHeader
              anonymizeResponses={page.anonymize_student_responses}
              blockType={presentedBlock?.t}
              className="gap-1 text-2xl text-black-tint-20"
              featureStatus={featureStatus}
              responseName={responseName}
              isPresenting
            />
          )}
        </div>

        <PageOverviewHeader
          className="px-0 md:px-0"
          isStaticContent={isStaticContent}
          page={page}
          isProjectorView
          readOnly
        />
      </div>
    </div>
  );
};
